export const isDemoCollegeLeaderboard = (email, type) =>
  String(email || '').trim().toLowerCase() === 'demo@snowsproam.com'
  && String(type || '').trim().toLowerCase() === 'college';

export const buildDemoCollegeLeaderboard = ({ realRows = [] } = {}) => {
  const byWorkspace = new Map();
  realRows.forEach((row) => {
    if (!row?.id || row.is_active === false || row.archived_at || row.teams) return;
    const key = row.workspace_id || row.id;
    if (byWorkspace.has(key)) return;
    const imageUrl = row.workspace_logo_url || row.brand_logo_url || row.image_url || '';
    byWorkspace.set(key, {
      ...row,
      type: 'College',
      institute_type: 'College',
      region: row.state_province,
      image: imageUrl,
      image_url: imageUrl,
      totalSteps: Number(row.total_steps ?? row.totalSteps) || 0,
      accessLocked: false,
    });
  });
  return [...byWorkspace.values()]
    .sort((a, b) => b.totalSteps - a.totalSteps || a.name.localeCompare(b.name))
    .map((row, index) => ({ ...row, rank: index + 1 }));
};
